/** Shared patch semantics: omission preserves, null resets to the read fallback,
 * empty strings/arrays clear. Defaults must never enter a write implicitly. */
export type SettingsPatch = { [key: string]: unknown };
export class SettingsInputError extends Error { status = 400; }
export class SettingsConflictError extends Error {
  status = 409;
  constructor() { super('Settings changed in another editor. Your input is preserved. Reload saved settings, review, and retry deliberately.'); }
}
export function isSettingsObject(value: unknown): value is SettingsPatch {
  return Boolean(value && typeof value === 'object' && !Array.isArray(value));
}
export function changedSettingsPatch(base: SettingsPatch, draft: SettingsPatch): SettingsPatch {
  const patch: SettingsPatch = {};
  for (const [key, value] of Object.entries(draft)) {
    if (value === undefined || JSON.stringify(value) === JSON.stringify(base[key])) continue;
    if (isSettingsObject(value)) {
      const nested = changedSettingsPatch(isSettingsObject(base[key]) ? base[key] : {}, value);
      if (Object.keys(nested).length) patch[key] = nested;
    } else patch[key] = value;
  }
  return patch;
}
